import { render, staticRenderFns } from "./GameCanvas.vue?vue&type=template&id=3c9cbf9e&scoped=true&"
import script from "./GameCanvas.vue?vue&type=script&lang=js&"
export * from "./GameCanvas.vue?vue&type=script&lang=js&"
import style0 from "./GameCanvas.vue?vue&type=style&index=0&id=3c9cbf9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9cbf9e",
  null
  
)

export default component.exports